
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { IInvoice } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/invoices';

interface IForm {
  memo: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true,
    },
  },
  data() {
    return {
      form: {
        memo: this.invoice.memo,
      },
    } as IState;
  },
  methods: {
    apiSubmit() {
      api.delivery(
        {
          invoiceId: this.invoice.id,
          memo: this.form.memo,
        },
        (res) => {
          if (!res.value) return;

          utils.success('发票开具操作成功！');
          this.$emit('submit');
        },
      );
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    invoice(value) {
      this.form.memo = value.memo;
    },
  },
});
